import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Star } from 'lucide-react';

const formatDate = (str) => {
  if (!str) return '—';
  try {
    return new Date(str).toLocaleString('pt-BR');
  } catch {
    return str;
  }
};

const notaTexto = (valor, naoAvaliado) => {
  if (naoAvaliado) return 'Não avaliou';
  if (valor == null || valor === '') return '—';
  return String(valor);
};

const Pesquisas = () => {
  const [pesquisas, setPesquisas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;
    const carregar = async () => {
      setLoading(true);
      setErro('');
      try {
        const { data } = await api.get('/pesquisas');
        if (!ativo) return;
        setPesquisas(data?.pesquisas || []);
      } catch (e) {
        if (!ativo) return;
        setErro(e.response?.data?.detail || 'Não foi possível carregar as pesquisas.');
      } finally {
        if (ativo) setLoading(false);
      }
    };
    carregar();
    return () => {
      ativo = false;
    };
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600">
          <Star className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Pesquisas</h1>
          <p className="text-slate-600">Avaliações do atendimento técnico</p>
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl bg-white shadow-sm">
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent" />
          </div>
        ) : erro ? (
          <p className="p-6 text-sm text-rose-700">{erro}</p>
        ) : pesquisas.length === 0 ? (
          <p className="p-6 text-sm text-slate-600">Nenhuma avaliação recebida ainda.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-left text-sm">
              <thead className="border-b border-slate-200 bg-slate-50 text-slate-500">
                <tr>
                  <th className="px-4 py-3 font-medium">Data</th>
                  <th className="px-4 py-3 font-medium">Laboratório</th>
                  <th className="px-4 py-3 font-medium">Quem preencheu</th>
                  <th className="px-4 py-3 font-medium">Técnico</th>
                  <th className="px-4 py-3 font-medium">Relatório</th>
                  <th className="px-4 py-3 font-medium">Nota serviço</th>
                  <th className="px-4 py-3 font-medium">Nota técnico</th>
                  <th className="px-4 py-3 font-medium">Nota equipamento</th>
                  <th className="px-4 py-3 font-medium">Comentário</th>
                </tr>
              </thead>
              <tbody>
                {pesquisas.map((item) => (
                  <tr key={item.id} className="border-b border-slate-100 align-top">
                    <td className="px-4 py-3 whitespace-nowrap text-slate-700">{formatDate(item.respondido_em)}</td>
                    <td className="px-4 py-3 font-medium text-slate-900">{item.cliente_nome || '—'}</td>
                    <td className="px-4 py-3 text-slate-700">{item.responsavel || '—'}</td>
                    <td className="px-4 py-3 text-slate-700">{item.tecnico_nome || '—'}</td>
                    <td className="px-4 py-3">
                      <Link to={`/relatorios-manutencao/${item.id}`} className="font-medium text-emerald-700 hover:underline">
                        {item.numero_relatorio || 'Abrir'}
                      </Link>
                    </td>
                    <td className="px-4 py-3">{notaTexto(item.nota_servico)}</td>
                    <td className="px-4 py-3">{notaTexto(item.nota_tecnico)}</td>
                    <td className="px-4 py-3">{notaTexto(item.nota_equipamento, item.equipamento_nao_avaliado)}</td>
                    <td className="px-4 py-3 max-w-xs whitespace-pre-wrap text-slate-600">{item.comentario || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Pesquisas;
